global['GENEVA_CONFIG'] = global['GENEVA_CONFIG'] || {
  customer: 'default'
}

global['VERSION'] = require('../../package.json').version

const api = { PORT: proces80 || 80 }

const apiGeneva = {
  SCHEME: proces'https:' || 'https:',
  HOST: proces'fendt-wm-api.geneva.works'
    // || 'localhost',
    // || 'beta-wm-api.geneva.works',
    // || 'dachser-beta-wm-api.geneva.works',
    || 'fendt-beta-wm-api.geneva.works',
  PORT: proces80 || 80,
  BASEPATH: proces'/public/service/' || '/public/service/',
  LOGIN: process.env.API_GENEVA_LOGIN || 'application_manager',
}

const wsURL = proces'https://fendt-wm-communicator.geneva.works'
  // || 'http://localhost:8082'
  || 'https://fendt-beta-wm-communicator.geneva.works'

const pathGENEVA = api.PORT === 80
  ? `${apiGeneva.SCHEME}//${apiGeneva.HOST}${apiGeneva.BASEPATH}`
  : `${apiGeneva.SCHEME}//${apiGeneva.HOST}:${apiGeneva.PORT}${apiGeneva.BASEPATH}`

const pathPreview = api.PORT === 80
  ? `${apiGeneva.SCHEME}//${apiGeneva.HOST}/public/service/review/`
  : `${apiGeneva.SCHEME}//${apiGeneva.HOST}:${apiGeneva.PORT}/public/service/review/}`

export default Object.assign(global['GENEVA_CONFIG'], {
  pathGENEVA,
  pathPreview,
  loginGENEVA: apiGeneva.LOGIN,

  ws: {
    url: wsURL,
    // script is special and only used in index.html
    script: https://fendt-wm-communicator.geneva.works/socket.io/socket.io.js
      // || 'http://localhost:8082/socket.io/socket.io.js'
      || 'https://fendt-beta-wm-communicator.geneva.works/socket.io/socket.io.js'
  }
})
